// extracted by mini-css-extract-plugin
export default {"item":"SubsidiesSplittingAll_item__ZrGCF","placeHolderShimmer":"SubsidiesSplittingAll_placeHolderShimmer__Wqm8z"};